
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'CsvFormatInfo'
})
export default class CsvFormatInfo extends Vue {}
